import { createRouter, createWebHistory } from 'vue-router';
import NotFoundPage from '@/pages/NotFoundPage';
import ServicesPage from '@/pages/ServicesPage';
import DocumentsPage from '@/pages/DocumentsPage';
import ApplicationsPage from '@/pages/ApplicationsPage';
import GisogdPage from '@/pages/GisogdPage';
import ObjectsPage from '@/pages/ObjectsPage';

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/services',
  },
  {
    path: '/services',
    name: 'services',
    component: ServicesPage,
  },
  {
    path: '/applications',
    name: 'applications',
    component: ApplicationsPage,
  },
  {
    path: '/documents',
    name: 'documents',
    component: DocumentsPage,
  },
  {
    path: '/gisogd',
    name: 'gisogd',
    component: GisogdPage,
  },
  {
    path: '/objects',
    name: 'objects',
    component: ObjectsPage,
  },
  {
    path: '/:catchAll(.*)',
    component: NotFoundPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
